import { Directive, HostListener } from '@angular/core';

@Directive({
	selector: '[tcOnlyTellNumber]',
	standalone: true
})
export class OnlyTellNumberDirective {
	regexStr = '^[0-9]*$';

	constructor() { }

	@HostListener('keydown', ['$event'])
	onKeyDown(event: KeyboardEvent): void {
		const e = <KeyboardEvent>event;

		if (
			[46, 8, 9, 27, 13, 110, 190, 171].indexOf(e.keyCode) !== -1 ||
			// Allow: Ctrl+A
			(e.keyCode === 65 && e.ctrlKey === true) ||
			// Allow: Ctrl+C
			(e.keyCode === 67 && e.ctrlKey === true) ||
			// Allow: Ctrl+V
			(e.keyCode === 86 && e.ctrlKey === true) ||
			// Allow: Ctrl+X
			(e.keyCode === 88 && e.ctrlKey === true) ||
			// Allow: home, end, left, right
			(e.keyCode >= 35 && e.keyCode <= 39) ||
			// Allow plus button
			e.keyCode === 107 ||
			e.keyCode === 187
		) {
			// let it happen, don't do anything
			return;
		}
		const ch = String.fromCharCode(e.keyCode);
		const regEx = new RegExp(this.regexStr);
		if (regEx.test(ch)) {
			return;
		} else if (
			(e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) &&
			(e.keyCode < 96 || e.keyCode > 105)
		) {
			e.preventDefault();
		}
	}

	@HostListener('paste', ['$event'])
	onPaste(event: ClipboardEvent) {
		let clipboardData = event.clipboardData;
		let text = clipboardData.getData('text');
		let i =0;
		let textLength = text.length;
		for ( i; i < textLength; i++)
		{
			if(!this.isValidChar(text[i])){
				event.preventDefault();
			}
		}	
		
	}

	isValidChar(char: string): boolean {
		if (
			"1234567890۱۲۳۴۵۶۷۸۹۰".indexOf(char) !== -1
		) {
			return true;
		}
		return false;
	}

}
